<template>
  <div class="document-creator-container py-4 px-2">
    <!-- Diálogo de creación -->
    <v-dialog v-model="previewCreate" persistent max-width="500">
      <v-card class="creator-dialog-card rounded-xl overflow-hidden elevation-24">
        <div class="dialog-header-gradient px-6 py-4 white--text d-flex align-center">
          <v-icon dark class="mr-3" size="24">mdi-clipboard-text-play-outline</v-icon>
          <span class="text-h6 font-weight-bold">Crear Nuevo Conteo</span>
        </div>

        <v-card-text class="px-6 pt-5 pb-2">
          <p class="text-body-2 grey--text text--darken-1 mb-4">
            Por favor, indique el departamento y centro de consumo (almacén) para iniciar el conteo de mercancías.
          </p>

          <v-text-field v-if="false" v-model="alias" label="Nombre documento"></v-text-field>

          <v-select :items="modulos" label="Departamento" outlined dense rounded prepend-inner-icon="mdi-domain"
            class="custom-select mt-2" @input="
              autoincrement++;
            $forceUpdate();
            " v-model="Departamento"></v-select>

          <v-select :items="origenes" label="Centro de consumo (Almacen)" outlined dense rounded
            prepend-inner-icon="mdi-warehouse" class="custom-select mt-2" @input="
              autoincrement++;
            $forceUpdate();
            " v-model="Origen" item-text="Nombre" item-value="id"></v-select>
        </v-card-text>

        <v-divider class="mx-6"></v-divider>

        <v-card-actions class="px-6 py-4 d-flex justify-end">
          <v-btn color="grey darken-1" text class="font-weight-medium rounded-lg px-4 mr-2"
            @click="goRoute('/productos-inventarios/conteoMercancias')">
            Cancelar
          </v-btn>
          <v-btn v-if="Departamento && Origen" color="primary" depressed
            class="font-weight-bold rounded-lg px-6 action-btn-shadow" @click="guardar()">
            Crear Documento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Overlay de carga estilizado -->
    <v-overlay v-if="loading" opacity="0.75" color="white" light>
      <div class="text-center">
        <v-progress-circular indeterminate size="64" color="primary" class="mb-4" width="4"></v-progress-circular>
        <div class="text-subtitle-1 font-weight-bold grey--text text--darken-3">Cargando Documento...</div>
      </div>
    </v-overlay>

    <!-- Layout principal -->
    <v-row class="ma-0">
      <!-- Tabla y Acciones del Documento (Derecha) -->
      <v-col cols="12" md="12" lg="12" class="pa-2">
        <!-- Encabezado del documento -->
        <div class="d-flex flex-wrap align-center justify-space-between mb-4 pb-3 border-bottom">
          <div>
            <div class="d-flex align-center flex-wrap">
              <h2 class="text-h5 font-weight-bold text-slate-800 mr-3 mb-0">{{ title }}</h2>
              <v-chip :color="estatusDocs == 'A' ? 'success' : 'warning'" class="font-weight-bold text-uppercase px-3"
                small label>
                <v-icon left size="16">
                  {{ estatusDocs == 'A' ? 'mdi-checkbox-marked-circle-outline' : 'mdi-file-document-edit-outline' }}
                </v-icon>
                {{ estatusDocs == 'A' ? 'Aplicado' : 'Borrador' }}
              </v-chip>
            </div>

            <!-- Fila de metadatos -->
            <div class="metadata-row d-flex flex-wrap align-center mt-2 text-caption grey--text text--darken-1">
              <span v-if="Fecha" class="mr-4 d-flex align-center">
                <v-icon size="14" class="mr-1" color="grey darken-1">mdi-calendar-plus</v-icon>
                Creado: {{ Fecha }}
              </span>
              <span v-if="FechaUpa" class="d-flex align-center">
                <v-icon size="14" class="mr-1" color="grey darken-1">mdi-calendar-edit</v-icon>
                Actualizado: {{ FechaUpa }}
              </span>
            </div>
          </div>

          <!-- Botones de Acción -->
          <div class="action-buttons d-flex flex-wrap mt-3 mt-sm-0">
            <v-btn color="grey lighten-3" light depressed
              class="mr-2 font-weight-bold rounded-lg action-btn text-slate-700"
              @click="goRoute('/productos-inventarios/conteoMercancias')">
              <v-icon left size="18">mdi-arrow-left</v-icon>
              Regresar
            </v-btn>

            <v-btn :loading="saving" depressed v-if="estatusDocs == 'C'" @click="guardar()" color="primary"
              class="mr-2 font-weight-bold rounded-lg action-btn">
              <v-icon left size="18">mdi-content-save-outline</v-icon>
              Guardar
            </v-btn>

            <v-btn :loading="saving" @click="guardar(true)" depressed
              v-if="estatusDocs == 'C' && this.$route.params.idDocumento" color="amber darken-3" dark
              class="mr-2 font-weight-bold rounded-lg action-btn">
              <v-icon left size="18">mdi-clipboard-check-outline</v-icon>
              Aplicar a Inventario
            </v-btn>

            <v-btn :loading="saving" depressed v-if="estatusDocs == 'C' && $route.params.idDocumento" color="success"
              @click="guardar(false, true)" class="font-weight-bold rounded-lg action-btn">
              <v-icon left size="18">mdi-play-circle-outline</v-icon>
              Iniciar Conteo
            </v-btn>
          </div>
        </div>

        <!-- Contenedor de la Tabla -->
        <v-row>
          <!-- Selector de Productos (Izquierda) -->
          <v-col cols="12" md="4" lg="3" class="pa-2">
            <v-card outlined class="product-picker-card rounded-xl pa-4">
              <div class="picker-header">
                <div class="d-flex align-center justify-space-between mb-2">
                  <div class="d-flex align-center">
                    <v-icon color="primary" class="mr-2" size="20">mdi-checkbox-multiple-marked-outline</v-icon>
                    <span class="text-subtitle-2 font-weight-bold text-slate-800">Agregar Productos</span>
                  </div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" @click="toogleCheck()" icon small class="toggle-check-btn">
                        <v-icon size="18" :color="selectedAll ? 'primary' : 'grey darken-2'">
                          {{ selectedAll ? 'mdi-checkbox-multiple-marked' : 'mdi-format-list-checks' }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ selectedAll ? 'Deseleccionar todos' : 'Seleccionar todos' }}</span>
                  </v-tooltip>
                </div>

                <div class="warehouse-badge d-flex align-center py-2 px-3 rounded-lg mb-3">
                  <div class="text-caption font-weight-bold truncate text-slate-800">
                    Almacén: {{ Origen ? (($pgsHelper.getById(origenes, "id", Origen)) || {}).Nombre || "Error"
                      : "Sin Almacén(Error)"
                    }}
                  </div>
                </div>
              </div>

              <div class="search-section mb-3">
                <v-autocomplete item-value="id" item-text="Nombre" :items="Categories" v-model="filterCategoria"
                  label="Filtrar por Categoría" outlined dense rounded hide-details class="mb-2 custom-input"
                  prepend-inner-icon="mdi-tag-outline"></v-autocomplete>
                <v-text-field v-model="filterProduct" label="Buscar Producto..." outlined dense rounded hide-details
                  class="custom-input" prepend-inner-icon="mdi-magnify" clearable></v-text-field>
              </div>

              <v-divider class="mb-2"></v-divider>

              <v-list style="max-height: 48vh" class="overflow-y-auto product-list-scroll rounded-lg py-0" flat>
                <template v-for="(producto, index) in comp_prod">
                  <v-list-item :key="index" class="product-list-item my-1 rounded-lg px-2"
                    :class="{ 'item-selected': producto.selectableProd }">
                    <v-list-item-action class="mr-2 my-0">
                      <v-checkbox v-model="producto.selectableProd" color="primary" hide-details
                        class="ma-0 pa-0"></v-checkbox>
                    </v-list-item-action>

                    <v-list-item-content class="py-2">
                      <v-list-item-title class="text-body-2 font-weight-medium text-slate-800 pr-1 truncate-2-lines">
                        {{ producto.Nombre }}
                      </v-list-item-title>
                      <v-list-item-subtitle
                        class="d-flex align-center justify-space-between mt-1 text-caption grey--text text--darken-1">
                        <span>{{ producto.Tipo }}</span>
                        <v-chip x-small class="stock-chip font-weight-bold"
                          :color="producto.existencia > 0 ? 'success' : 'grey lighten-2'"
                          :text-color="producto.existencia > 0 ? 'green' : 'grey darken-3'" outlined>
                          Stock: {{ producto.existencia }} {{ producto.unidad }}
                        </v-chip>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <div v-if="comp_prod.length === 0" class="text-center py-8 px-4 grey--text text--lighten-1">
                  <v-icon size="36" color="grey lighten-2" class="mb-2">mdi-package-variant</v-icon>
                  <div class="text-caption">No se encontraron productos</div>
                </div>
              </v-list>

              <v-btn color="primary" @click="addToDoc()" depressed large block
                class="mt-3 rounded-lg font-weight-bold add-doc-btn">
                Agregar a documento
                <v-icon right>mdi-arrow-right-circle-outline</v-icon>
              </v-btn>
            </v-card>
          </v-col>
          <v-col cols="12" md="8" lg="9" class="pa-2">
            <v-card class="table-container-card rounded-xl pa-4 mt-2" elevation="0">
              <div class="d-flex align-center justify-space-between mb-4">
                <div class="d-flex align-center">
                  <v-icon color="secondary" class="mr-2" size="22">mdi-format-list-bulleted</v-icon>
                  <span class="text-subtitle-1 font-weight-bold text-slate-800">Productos del Documento</span>
                </div>
                <v-chip class="font-weight-bold" color="grey lighten-4" text-color="slate-800" small>
                  Total: {{ productsDocument.length }} items
                </v-chip>
              </div>

              <uv-data-table :config="config" :data="productsDocument" :pageRows="30"
                @buttonClick="dtButtonClick"></uv-data-table>
            </v-card>
          </v-col>
        </v-row>

      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.menubtn {
  display: none;
}

.text-slate-800 {
  color: #1e293b !important;
}

.text-slate-700 {
  color: #334155 !important;
}

.border-bottom {
  border-bottom: 1px solid #e2e8f0;
}

.dialog-header-gradient {
  background: linear-gradient(135deg, #1e3a8a, #3b82f6);
}

.creator-dialog-card {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
}

.custom-select /deep/ .v-input__slot {
  border-radius: 8px !important;
}

.product-picker-card {
  background-color: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02) !important;
}

.warehouse-badge {
  background-color: #eff6ff;
  color: #1e40af;
  border: 1px solid #dbeafe;
}

.toggle-check-btn {
  background-color: #f1f5f9;
  transition: all 0.2s ease;
}

.toggle-check-btn:hover {
  background-color: #e2e8f0;
}

.custom-input /deep/ .v-input__slot {
  background-color: #f8fafc !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: none !important;
  transition: all 0.2s ease;
}

.custom-input /deep/ .v-input__slot:focus-within {
  border-color: #3b82f6 !important;
  background-color: #ffffff !important;
}

.product-list-scroll::-webkit-scrollbar {
  width: 5px;
}

.product-list-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.product-list-scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}

.product-list-scroll::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

.product-list-item {
  border: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.product-list-item:hover {
  background-color: #f8fafc !important;
  border-color: #cbd5e1;
}

.product-list-item.item-selected {
  background-color: #f0fdf4 !important;
  border-color: #bbf7d0;
}

.stock-chip {
  font-size: 0.7rem !important;
  height: 18px !important;
}

.add-doc-btn {
  letter-spacing: 0.3px;
  text-transform: none;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15) !important;
  transition: all 0.3s ease;
}

.add-doc-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(59, 130, 246, 0.25) !important;
}

.action-btn {
  text-transform: none;
  letter-spacing: 0.2px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.action-btn:hover {
  transform: translateY(-1px);
}

.table-container-card {
  background-color: #ffffff !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05) !important;
}

.truncate-2-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  line-height: 1.25;
}
</style>

<script>
import uvDataTable from "../../MainComponents/DataTable.vue";
import moment from "moment";
import DocumentosConteo from "../../../clases/PdfMakers/DocumentosConteo";
import pdfmake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { mapActions } from "vuex";
pdfmake.vfs = pdfFonts.pdfMake.vfs;
export default {
  name: "DocumentosCreator",
  components: {
    uvDataTable,
  },
  props: [],
  data() {
    return {
      OrnData: {},
      saving: false,
      Departamento: null,
      estatusDocs: "C",
      autoincrement: 0,
      filterProduct: "",
      filterCategoria: "ALL",
      selectedAll: false,
      alias: "",
      previewCreate: false,
      Origen: null,
      loading: false,
      Aplicado: false,
      title: "Nuevo documento de conteo de inventarios",
      showModal: false,
      showModalExist: false,
      formExistKey: 0,
      newLoadData: false,
      productsDocument: [],
      editData: [],
      Categories: [],
      config: {
        selectableRow: true,
        allowExport: true,
        rawText: "Conteos",
        selectConfig: {
          multiSelect: false,
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol: { Field: "", Type: "Asc" },
        buttons: [
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteDocumentProduct",
            require: true,
            limitRequire: 1,
          },
          {
            text: "PDF",
            icon: "lni lni-download",
            buttonId: "docsToPdf",
            require: false,
          },
        ],
        fields: [
          {
            text: "Nombre",
            value: "nm",
          },
          {
            text: "Conteo",
            value: "cn",
          },
          {
            text: "Unidad",
            value: "Unidad",
          },
        ],
      },
      Fecha: null,
      FechaUpa: null,
    };
  },
  methods: {
    async generatePdf() {
      console.log();
      let mainData = {
        TITLE: "Conteo - " + this.$route.params.idDocumento,
        FF: this.Fecha,
        FU: this.FechaUpa,
        FG: new moment().format("DD/MM/YYYY"),
        HG: new moment().format("HH:mm:ss"),
        dep: this.Departamento,
        data: this.productsDocument,
        status: this.estatusDocs == "A",
      };
      let docData = DocumentosConteo.getDocData(mainData);
      pdfmake.createPdf(docData).open();
    },

    toogleCheck() {
      this.selectedAll = !this.selectedAll;
      this.$store.getters.getProductos.forEach((prod) => {
        prod.selectableProd = this.selectedAll;
      });
      this.$forceUpdate();
    },
    addToDoc() {
      this.comp_prod.forEach((prod) => {
        if (prod.selectableProd) {
          this.saveExistProduct(prod);
        }
      });
    },
    goRoute(routePath) {
      this.$router.push({ path: routePath });
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "docsToPdf") {
        this.generatePdf();
      } else if (this.estatusDocs == "A") {
        this.$swal(
          "No puedes modificar un documento aplicado a inventario",
          "",
          "error"
        );
        return false;
      }
      if (buttonId == "deleteDocumentProduct") {
        this.deleteItem(idSelected);
      }
    },
    successData(data, doAction) {
      if (doAction == "CREATE") {
        alert("Creando");
        this.$pgsHelper.log(data);
      } else if (doAction == "EDIT") {
        alert("editando");
        this.$pgsHelper.log(data);
      }
    },
    saveExistProduct(datos) {
      if (this.$pgsHelper.getById(this.productsDocument, "id", datos.id)) {
        this.showModalExist = false;
        return false;
      } else {
        let existProduct = this.$pgsHelper.getById(this.$store.getters.getProductos, "id", datos.id)
        this.productsDocument.push({
          id: datos.id,
          _e: true,
          cn: 0,
          nm: datos.Nombre,
          Unidad: ((existProduct) ? ((existProduct?.Extra?.AYB?.UM) ? existProduct?.Extra?.AYB?.UM : "PZA") : "-")
        });
        this.showModalExist = false;
      }
    },
    toggleModal(open) {
      this.showModal = open;
    },
    verifySelectedOrigen(callback) {
      if (this.Origen == "") {
        this.$swal("Seleccione un centro de consumo", "", "error");
        return false;
      }
      {
        callback();
      }

      return true;
    },
    async getDocumentInfo(id) {
      this.productsDocument = [];
      this.loading = true;
      this.productos = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      const doc = firestore.doc("AMC_ConteosInventario/", id);
      const data = await firestore.getDoc(doc);

      //this.$pgsHelper.log(data.docs.map(doc=>{return {id:doc.ref.id,...doc.data()}}));
      let document = { id: data.ref.id, ...data.data() };

      this.Aplicado = document.Aplicado;
      if (!document.cto) {
        document.cto = {};
      }
      this.OrnData = document;
      let productos = Object.entries(document.cto);
      this.Origen = document.amc;
      this.estatusDocs = document.sts;
      if (this.estatusDocs == "A") {
        this.config.fields = [
          {
            text: "Nombre",
            value: "nm",
          },
          {
            text: "Conteo",
            value: "cn",
          },
          {
            text: "Diferencia",
            value: "ce.ei",
          },
          {
            text: "Unidad",
            value: "Unidad",
          },
        ]
      }
      this.Departamento = document.dpt;
      this.autoincrement++,
        productos.forEach((element) => {
          let datos = element[1];
          let existProduct = this.$pgsHelper.getById(this.$store.getters.getProductos, "id", element[0])
          this.productsDocument.push({
            id: element[0],
            Unidad: ((existProduct) ? ((existProduct?.Extra?.AYB?.UM) ? existProduct?.Extra?.AYB?.UM : "PZA") : "-"),
            ...datos,
          });
        });
      this.productsDocument.sort((a, b) => {
        if (a.nm.toLowerCase() < b.nm.toLowerCase()) return -1;
        if (a.nm.toLowerCase() > b.nm.toLowerCase()) return 1;
        return 0;
      });
      let fecha = null;
      let fechaUpa = null;
      let updatedBy = "";
      let createdBy = "";
      if (document.mta.cra) {
        fecha = new moment(document.mta.cra.t);
        createdBy = document.mta?.cra?.u?.n;
      }
      if (document.mta.upa) {
        fechaUpa = new moment(document.mta.upa.t);
        updatedBy = document.mta?.upa?.u?.n;
      }
      this.Fecha = fecha ? fecha.format("YYYY-MM-DD HH:mm") : "";
      this.FechaUpa = fechaUpa ? fechaUpa.format("YYYY-MM-DD HH:mm") : "";
      this.loading = false;
    },
    guardar(sendInv = false, startAccount = false) {
      if (this.Origen == "") {
        this.$swal(
          "Seleccione un centro de consumo",
          "Para continuar por favor indique el centro de consumo al que iran los productos",
          "error"
        );
        return false;
      }
      let data = {
        ...this.OrnData,
        amc: this.Origen,
        cto: {},
        sts: this.estatusDocs, //A|R
        dpt: this.Departamento,
      };
      this.productsDocument.forEach((element) => {
        /*data.Productos.push({
          Id: element.id,
          Nombre: element.Nombre,
          Factura: element.Factura,
          Cantidad: parseInt(element.Cantidad),
          PreVenta: parseFloat(element.PreVenta),
          PreCompra: parseFloat(element.PreCompra),
          MonCompra: element.MonCompra,
          MonVenta: element.MonVenta,
          Moneda: element.Moneda,
        });*/
        data.cto[element.id] = element;
      });
      this.$pgsHelper.log(data);
      if (this.$route.params.idDocumento) {
        this.editDocument(data, sendInv, startAccount);
      } else {
        this.saveDocument(data, sendInv);
      }
    },
    saveSend() {
      this.guardar(true);
    },
    sendInventario() {
      this.saving = true;
      let datos = {
        Id: this.$route.params.idDocumento,
        TipoMovimiento: "Conteo",
      };
      this.$store.getters.getFirebaseApp.fba
        .call("AMC-ConteosInventario-applyConteoInventario", datos)
        .then((result) => {
          if (result) {
            if (result.data.ok) {
              this.getDocumentInfo(this.$route.params.idDocumento);
              this.saving = false;
              this.$swal({
                title: "Guardado",
                text: "El documento se envio a inventario corretamente",
                icon: "success",
              });
            } else {
              this.saving = false;
              this.$swal(
                "Error aplicando inventario",
                result.data.error,
                "error"
              );
            }
          }
        })
        .catch((error) => {
          this.saving = false;
          this.$swal({
            title: "Error",
            text: `Request failed: ${error}`,
            icon: "error",
          });
        });
    },
    deleteItem(id) {
      this.productsDocument.forEach((element, index) => {
        if (element.id == id) {
          this.productsDocument.splice(index, 1);
        }
      });
    },
    saveDocument(datos, sendInv) {
      this.$swal({
        title: "¿Deseas crear este nuevo documento de conteo de mercancias?",
        text: "Se registrar el documento y sus productos indicados ",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AMC-ConteosInventario-createConteoInventario", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.getDocumentInfo(result.value.data.data.Id);
            this.$swal({
              title: "Guardado",
              text: "El documento se guardo corretamente",
              icon: "success",
            });
            this.$router.push({
              path:
                "/productos-inventarios/documentoConteo/" +
                result.value.data.data.Id,
            });
            this.previewCreate = false;
            if (sendInv) {
              this.sendInventario();
            }
          } else {
            this.$swal(
              "Error guardando Documento",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    editDocument(datos, sendInv, startAccount) {
      this.saving = true;
      this.$pgsHelper.log(datos);

      datos.Id = this.$route.params.idDocumento;
      this.$store.getters.getFirebaseApp.fba
        .call("AMC-ConteosInventario-updateConteoInventario", datos)
        .then((result) => {
          if (result) {
            if (result.data.ok) {
              this.getDocumentInfo(this.$route.params.idDocumento);
              this.saving = false;
              if (sendInv) {
                this.sendInventario();
              }

              if (startAccount) {
                this.goRoute(
                  "/productos-inventarios/conteo/" +
                  this.$route.params.idDocumento
                );
              }
            } else {
              this.saving = false;
              this.$swal("Error saving Documentos", result.data.error, "error");
            }
          }
        })
        .catch((error) => {
          this.$swal({
            title: "Error",
            text: `Request failed: ${error}`,
            icon: "error",
          });
          this.saving = false;
        });
    },
    ...mapActions("Categorias", { fetchCategories: "getCategories" }),
    async getCategories() {
      const cats = await this.fetchCategories();
      this.Categories = [{ id: "ALL", Nombre: "TODOS" }, ...cats];
    },
  },
  computed: {
    modulos() {
      let dep = [
        /*{ value: "", text: "Seleccione un modulo" }*/
      ];
      let departamentos = this.$store.getters.getPDVDepartamentos;
      departamentos.forEach((element) => {
        dep.push({ value: element.id, text: element.Nombre });
      });
      return dep;
    },
    comp_prod() {
      try {
        if (!this.Origen) {
          return [];
        }
        let producto = this.$store.getters.getProductos;
        let origenes = this.$store.getters.getOrigenes;
        let origenesToUse = [];

        origenes.forEach((origen, index) => {
          let exist = this.$pgsHelper.getById(
            origenesToUse,
            "Origen",
            origen.Origen
          );
          if (!exist) {
            origenesToUse.push(origen);
          } else {
            for (let clave in origen.Productos) {
              origenesToUse[exist.idx].Productos[clave] =
                origen.Productos[clave];
            }
          }
        });
        let listadoProductos = [];
        producto.forEach((element) => {
          if (element.id == "1MJQkPxbZuv2h97a1xuR") {
            console.log(element);
          }

          let productoData = this.$pgsHelper.cloneObj(element);
          if (
            productoData.Tipo != "Servicio" &&
            productoData.Tipo != "Producto-NInv" &&
            productoData.Tipo != "AYB-Producto" &&
            !productoData.Dlat
          ) {
            productoData.selectableProd = this.selectedAll;
            let centroConsumo = this.$pgsHelper.getById(
              origenesToUse,
              "Origen",
              this.Origen
            );

            let productOrigen = null;
            if (centroConsumo) {
              if (productoData.id == "1MJQkPxbZuv2h97a1xuR") {
                console.log("Origen", centroConsumo.Productos[productoData.id]);
              }
              if (centroConsumo.Productos[productoData.id]) {
                productOrigen = centroConsumo.Productos[productoData.id];
                productoData.existencia = Number(productOrigen.Stock);
                productoData.unidad = productoData?.Extra?.AYB?.UM || "PZA";
              }
            }
            if (productoData.existencia || productoData.existencia === 0) {
              if (productoData.existencia === 0) {
                productoData.existencia = 0;
              }
              listadoProductos.push(this.$pgsHelper.cloneObj(productoData));
            }
          }
        });
        let productosFiltrados = listadoProductos;
        if (this.filterCategoria !== "ALL") {
          let filtradosCategoria = this.$_.map(listadoProductos, (o) => {
            if (o.Categoria == this.filterCategoria) {
              return o;
            }
          });
          productosFiltrados = this.$_.without(filtradosCategoria, undefined);
          //return filter;
        }

        if (this.filterProduct !== "") {
          let filter = this.$_.map(productosFiltrados, (o) => {
            if (
              o.Nombre.toUpperCase().includes(this.filterProduct.toUpperCase())
            )
              return o;
          });
          filter = this.$_.without(filter, undefined);
          return filter;
        }

        return productosFiltrados;
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    origenes() {
      let ori = this.$store.getters.getCentrosConsumo;
      return ori;
    },
  },
  watch: {},
  mounted() {
    this.getCategories();
  },
  created() {
    if (this.$route.params.idDocumento) {
      this.title = "Edición de documento : " + this.$route.params.idDocumento;
      this.getDocumentInfo(this.$route.params.idDocumento);
    } else {
      this.previewCreate = true;
    }
  },
};
</script>
